<template>
    <div class="guidedetail">
        <div class="question_title">
            <div>
                <span>
                    {{title[titileIndex]}}
                </span>
                <div class="line"></div>
            </div>
        </div>

        <!-- 全套里面是所有的病历吗？ -->
        <div class="question_contain" v-if="one">
            <div class="contain_part">全套包含医院可提供患者的全部病历，其可以用于各种报销用途。</div>
        </div>
        <!-- 什么时间付款？如何付款？ -->
        <div class="question_contain" v-if="two">
            <div class="contain_part">根据医院的病案室相关《病案管理规定》，一般为患者出院后7~15个工作日，可复印和付款。</div>
            <div class="contain_part">当您的病案可以复印时，您会收到公众号推送的付款通知，您用微信支付即可支付。</div>
            <div class="contain_part">复印费按照医院标准收取， 快递费按照快递公司相关收费标准收取。如患者有病理报告，按病理检查报告单生成时间为准。</div>
        </div>
        <!-- 没有身份证如何申请？ -->
        <div class="question_contain" v-if="three">
            <div class="contain_part">可选其他有效证件类型，如户口本、护照和港澳通行证等，可在申请页面选择相应的证件类型。</div>
        </div>
        <!-- 新生儿如何申请？ -->
        <div class="question_contain" v-if="four">
            <div class="contain_part">需要新生儿出生证明，父亲或母亲的手持身份证照片，父亲或母亲的身份证正面照片。</div>
            <div class="contain_part">如还没有出生证明， 需要父亲或母亲的手持身份证正面照片，父亲或母亲的身份证正面照片，父亲或母亲的身份证反面照片。</div>
        </div>
        <!-- 患者死亡如何申请？ -->
        <div class="question_contain" v-if="five">
            <div class="contain_part">患者身份证正面（患者户口本首页和患者户口本本人页）、居民医学死亡证明、代办人身份证正面、
    代办人身份证反面、代办人手持身份证（代办人户口本本人页）、派出所开具的代办人和患者关系证明。</div>
        </div>
        <!-- 病历复印规定 -->
        <div class="question_contain" v-if="six">
            <div class="contain_part">    根据国务院《医疗事故处理条例》及卫生部2013版《医疗机构病历管理规定》的有关条款。医院有保存就诊患者医学资料的义务，
                医院病案室负责病历的保管、查阅（复制）工作。医院规定除病历质量检查、纠纷病历封存、医保查费和医院感染管理需要外，任何人未经同意一律不得外借原始病历，
                只能查阅或复制相关病历资料。</div>
            <div class="contain_part"><p>申请复制病历所需资料</p><p>（一）申请人为患者本人：须提供本人有效身份证明</p>
                <p>（二）申请人为患者代理人：&nbsp;&nbsp;</p>
                <p>&nbsp;①患者有效身份证明</p>
                <p><span style="letter-spacing: 0px; line-height: 1.6;">&nbsp;②代理人有效身份证明</span></p>
                <p>&nbsp;③患者委托代理人复制病历的授权委托书</p>
                <p>（三）申请人为死亡患者法定继承人：</p>
                <p>①患者死亡证明</p>
                <p>②法定继承人有效身份证明</p>
                <p>③法定继承人与死亡患者关系的法定证明材料</p>
                <p>（四）申请人为死亡患者法定继承人代理人：</p>
                <p>①患者死亡证明</p>
                <p>②法定继承人、其代理人的有效身份证明</p>
                <p>③死亡患者与法定继承人关系的法定证明材料</p>
                <p>④法定继承人委托代理人复制病历的授权委托书</p>
                <p>（五）申请人为公检法等，因办案、依法实施专业技术鉴定、医疗保险审核或仲裁等：</p>
                <p>①该机构出具的调取病历法定证明</p>
                <p>②经办人本人有效身份证明</p>
                <p>③经办人本人有效工作证明</p>
                <p>（六）申请人为商业保险机构：</p>
                <p>①该保险机构出具的调取病历法定证明</p>
                <p>②保险合同复制件</p>
                <p>③患者本人（法定继承人）或者其代理人<span style="text-decoration: underline;">同意</span>的法定证明材料</p>
                <p>（七）患者为未成年人时：</p>
                <p><span style="letter-spacing: 0px; line-height: 1.8;">①患者的户口本或出生证明</span></p>
                <p><span style="letter-spacing: 0px; line-height: 1.8;">②法定监护人有效身份证件</span></p>
                <p>③如果法定监护人委托代理人复制病历，除上述资料外，还须提供授权委托书</p>
            </div>
            <div class="note">注：以上验证信息材料仅供参考，请根据医院的具体要求上传所需验证材料</div>
        </div>
        <div class="question_contain" v-if="ten">
            <div class="contain_part">中草药/中草药代煎邮寄选用EMS邮政特快专递，邮寄会给你合适的纸箱包装好，正常三天内就可以收到，代煎的中草药会选用气泡膜包裹好，很快很安全</div>
        </div>

        <!-- 用户隐私概要？ -->
        <div class="question_contain" v-if="eleven">
            <div class="tip-con-info">
            亲，感谢您信任并使用本小程序病案通！我们依据最新的法律法规、监管政策要求及业务实际情况更新了小程序病案通
            <span
              style="display: inline; color: #009e92"
              @click="gotoPrivacyPolicy"
              >《病案通隐私政策》</span
            >、
            <span
              style="display: inline; color: #009e92"
              @click="gotoChildInfoRules"
              >《儿童个人信息保护规则》</span
            >、
            <span
              style="display: inline; color: #009e92"
              @click="gotoCommunityRules"
              >《医服通社区自律公约》</span
            >、
            <span
              style="display: inline; color: #009e92"
              @click="gotouserRegistration"
              >《医服通用户注册协议》</span
            >。
          </div>
        </div>
    </div>
</template>
<script>
export default {
  name: "guidedetail",
  data() {
    return {
      one: false,
      two: false,
      three: false,
      four:false,
      five:false,
      six:false,
      seven:false,
      eight:false,
      nine:false,
      ten:false,
    //   其他内容
    //   nine:false,
    //   ten:false,
    //   eleven:false,
      title:['全套里面是所有的病历吗?','什么时间付款？如何付款？','没有身份证如何申请？','新生儿如何申请？','患者死亡如何申请？','病历复印规定',
            '如何微信申请病历？','如何联系病案通客服获取帮助？','《转外就医申请表》盖章材料？','《医保资质证明》如何办理？','如何补打《出院费用结算清单》',
            '客服热线','中草药怎么邮寄','用户隐私政策概要'],
      titileIndex:''     
    }
  },
  created(){
      let id = this.$route.params.id;
      console.log(id)
      switch(id){
          case'one':
          this.one = true
          this.titileIndex = 0
          break;
          case'two':
          this.two = true
          this.titileIndex = 1
          break;
          case'three':
          this.three = true
          this.titileIndex = 2
          break;
          case'four':
          this.four = true
          this.titileIndex = 3
          break;
          case'five':
          this.five = true
          this.titileIndex = 4
          break;
          case'six':
          this.six = true
          this.titileIndex = 5
          break;
          // case'seven':
        //   this.seven = true
        //   this.titileIndex = 6
            // window.location.href = 'https://mp.weixin.qq.com/s/DgMJH__xsKtqg18v7iU7yQ'; 

          // break;
        //   case'eight':
        // //   this.eight = true
        // //   this.titileIndex = 7
        // window.location.href = 'https://mp.weixin.qq.com/s/-gkd6g3ZNJGWl48nNpPJTg'; 
        //   break;
        //   case'nine':
        // //   this.eight = true
        // //   this.titileIndex = 7
        // this.$router.push({
				// 	path: '/hotline'
        //         })
        //   break;
          case'ten':
          this.ten = true
          this.titileIndex = 12
          break;
          case'eleven':
          this.eleven = true
          this.titileIndex = 13
          break;
// 其他内容
        //   case'nine':
        //   this.nine = true
        //   this.titileIndex = 8
        //   break;
        //   case'ten':
        //   this.ten = true
        //   this.titileIndex = 9
        //   break;
        //   case'eleven':
        //   this.eleven = true
        //   this.titileIndex = 10
        //   break;
      }
  },
  methods: {
     // 规则条款
    gotoPrivacyPolicy(){
      window.open('https://m.vmeeting.cn/rules/privacy_policy.html');   
    },
    gotoChildInfoRules(){
      window.open('https://m.vmeeting.cn/rules/child_info_rules.html');   
    },
    gotoCommunityRules(){
      window.open('https://m.vmeeting.cn/rules/community_rules.html');   
    },

    gotouserRegistration(){
      window.open('https://m.vmeeting.cn/rules/user_registration.html');   
    },
  }

};
</script>
<style>
.guidedetail {
  background: white;
  /* height: 100%; */
  padding: 20px 15px;
}
.question_title span {
  font-size: 18px;
  font-weight: bold;
}
.line {
  width: 100%;
  border-bottom: 1px solid #d9d9d9;
  margin: 10px 0;
}
.question_contain {
  line-height: 26px;
  font-size: 15px;
}
.contain_part {
  margin-bottom: 8px;
}
.note{
    color:#666666;
    /* float: right; */
    font-size: 15px;
    padding: 10px;
}
.tip-con-info {
  padding: 0 30px;
}
</style>


